<template>
  <div id="app">
    <!--<canvas id="connections-effect-canvas" class="d-none d-xl-block" style="z-index: -1;"></canvas>-->
    <router-view/>
    
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  },
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
